<template>
  <div class="marquee-gallery-wrapper">
    <div v-if="!isDevice()" ref="cursor-follower" class="cursor-follower">
      <div v-show="cursor.active" class="cursor" :class="[cursor.position]"><span>x</span>{{ cursor.text }}</div>
    </div>

    <div class="marquee6k marquee-gallery" data-speed="0.5">
      <div>
        <img v-for="(photo, index) in photos" :src="photo.src" class="img" @load="onImageLoad" />
      </div>
    </div>

    <button type="button" class="navigation-button-prev" @click="toggleSpeed(-1)">
      <i class="icon-arrow-slim-left"></i>
    </button>

    <button type="button" class="navigation-button-next" @click="toggleSpeed(1)">
      <i class="icon-arrow-slim-right"></i>
    </button>
  </div>
</template>

<script>
import marquee6k from 'marquee6k';
import gsap from "gsap";

export default {
  props: {
    photos: {
      type: Array,
      default: () => [],
      required: true
    },
  },
  data() {
    return {
      loadedCount: 0,
      cursor: {
        x: 0,
        y: 0,
        active: false,
        text: '',
        position: 'right'
      }
    }
  },
  methods: {
    onImageLoad() {
      this.loadedCount++;

      if (this.loadedCount === this.photos.length) {
        this.$emit('ready');
        marquee6k.init();
      }
    },
    toggleSpeed(multiplier) {
      let newReverse;

      if (multiplier < 0) {
        newReverse = true;
      } else {
        newReverse = false;
      }

      window.MARQUEES.forEach(instance => {
        if (instance.reverse != newReverse) {
          this.cursor.text = '';
          instance.speed = 0.5;
          instance.reverse = newReverse;
        } else if (instance.speed === 0.5) {
          this.cursor.text = '2';
          instance.speed = 5;
        } else if (instance.speed === 5) {
          this.cursor.text = '3';
          instance.speed = 10;
        } else if (instance.speed === 10) {
          this.cursor.text = '';
          instance.speed = 0.5;
        }
      });
    },
    onMoveCursor(e) {
      this.cursor.x = e.clientX;
      this.cursor.y = e.clientY;
    },
    isDevice() {
      let check = false;
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    },
    onBtnMouseOver(e) {
      const buttonClass = e.target.className;

      if (buttonClass === 'navigation-button-prev') {
        this.cursor.position = 'right';
      }

      if (buttonClass === 'navigation-button-next') {
        this.cursor.position = 'left';
      }

      this.cursor.active = true;
    },
    onBtnMouseLeave() {
      this.cursor.active = false;
    },
    onMouseWheel(event) {
      if (event.deltaY < 0) {
        window.MARQUEES.forEach(instance => {
          instance.speed = -50;

          setTimeout(() => {
            instance.speed = -0.5;
          }, 1000);
        })
      } else {
        window.MARQUEES.forEach(instance => {
          instance.speed = 50;

          setTimeout(() => {
            instance.speed = 0.5;
          }, 1000);
        })
      }
    }
  },
  mounted() {
    if (!this.isDevice()) {
      document.addEventListener("mousemove", this.onMoveCursor, {
        passive: true,
      });

      // document.addEventListener("wheel", this.onMouseWheel, {
      //   passive: true,
      // });

      document.addEventListener("mousewheel", this.onMoveCursor, {
        passive: true,
      });

      const buttons = document.querySelectorAll('.marquee-gallery-wrapper button');

      buttons.forEach((button) => {
        button.addEventListener("mouseover", this.onBtnMouseOver, {
          passive: true,
        });

        button.addEventListener("mouseleave", this.onBtnMouseLeave, {
          passive: true,
        });
      });

      const element = document.querySelector(".cursor-follower");

      let pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
      const speed = 1;
      const fpms = 60 / 1000;

      const setXposition = gsap.quickSetter(element, "left", "px");
      const setYposition = gsap.quickSetter(element, "top", "px");

      gsap.ticker.add((time, deltaTime) => {
        let delta = deltaTime * fpms;
        let dt = 1.0 - Math.pow(1.0 - speed, delta);

        pos.x += (this.cursor.x - pos.x) * dt;
        pos.y += (this.cursor.y - pos.y) * dt;

        setXposition(pos.x);
        setYposition(pos.y);
      });
    }
  },
  destroyed() {
    if (!this.isDevice()) {
      document.removeEventListener("mousemove", this.onMoveCursor);
    }
  },
}

</script>

<style lang="scss">
.marquee-gallery-wrapper {
  position: relative;

  .marquee-gallery {
    height: 100%;
    overflow: hidden;
    white-space: nowrap;

    .marquee6k__wrapper {
      height: 100%;

      .marquee6k__copy {
        height: 100%;
      }
    }
  }

  .img {
    margin: 0 10px;
    width: auto;
    height: 100%;
  }

  button.navigation-button-prev,
  button.navigation-button-next {
    width: 50%;
    height: 100%;
    position: absolute;
    top: 0;
    z-index: 1;
  }

  button.navigation-button-prev {
    left: 0;
    cursor: url("../images/cursor_left.svg") 25 25, pointer;
  }

  button.navigation-button-next {
    right: 0;
    cursor: url("../images/cursor_right.svg") 25 25, pointer;
  }
}

.cursor-follower {
  pointer-events: none;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  will-change: left, top, width, height;
  transition-property: width, height;
  transition-duration: 250ms;
  transition-timing-function: ease-in-out;
  z-index: 99999;
  mix-blend-mode: difference;
  color: #fff;

  .cursor {
    position: absolute;
    top: 0;
    right: 100%;
    font-size: 1rem;

    span {
      position: absolute;
      font-size: 0.725rem;
      top: 50%;
      transform: translateY(-50%);
    }

    &.left {
      transform: translate(-300%, -65%);

      span {
        right: 100%;
      }
    }

    &.right {
      transform: translate(300%, -65%);

      span {
        left: 100%;
      }
    }
  }
}

@media only screen and (min-width: 768px) {
  .marquee-gallery-wrapper {
    .img {
      margin: 0 20px;
    }
  }
}
</style>